import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DateTime } from "luxon";
import { getPJPDetails } from "_controllers/officer";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import authAxios from "setups/axios";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import exportExcel from "utils/excelGenerate";
import moment from "moment";

const PJPList = () => {
  const { SAP_ID } = useParams();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [beats, setBeats] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [message, setMessage] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [modelData, setModelData] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [remark, setRemark] = useState('')

  const [Values, setValues] = useState({
    selectStartDate: '',
    selectEndDate: '',
  });

  const fileName = `${SAP_ID}-pjp-data`;

  useEffect(async () => {
    // if (!planDate || !SAP_ID) return;

    // const today = DateTime.now();

    // const startDate =
    //   today.day > 27
    //     ? today.plus({ months: 1 }).startOf("month")
    //     : today.startOf("month");

    // const endDate = startDate.endOf("month");

    // setStartDate({
    //   year: startDate.year,
    //   month: startDate.month,
    //   day: startDate.day,
    // });
    // setEndDate({
    //   year: endDate.year,
    //   month: endDate.month,
    //   day: endDate.day,
    // });

    const start = startDate ? startDate : moment().startOf("month").format("YYYY-MM-DD");

    const end = endDate ? endDate : moment().endOf("month").format("YYYY-MM-DD");
    const newmonth = moment().add(1, 'M').startOf('month').format('YYYY-MM-DD')
    console.log("data", newmonth)

    const plan = await getPJPDetails({
      SAP_ID,
      startDate: start,
      endDate: end,
    });
    console.log("huft", plan?.data)
    setData(plan?.data);
    setCsvData(plan)
    setLoading(true);
  }, [message, startDate, endDate]);

  const handleApprove = async (id) => {
    const response = await authAxios()({
      url: `/api/v1/AM/PJP/approve/${id}`,
      method: "GET",
    });
    setMessage(response?.data.message);
  };

  const handleRevert = async (id) => {
    const response = await authAxios()({
      url: `/api/v1/AM/PJP/revert/${id}`,
      method: "GET",
    });
    setMessage(response?.data.message);
  };

  const messageStyle = {
    position: "absolute",
    // height: '500px',
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    textAlign: "center",
  };

  const approvedStyle = {
    color: 'green',
    fontWeight: "bolder"
  }
  const normalStyle = { fontWeight: "bolder" }

  const revertedStyle = {
    color: "red",
    fontWeight: "bolder"
  }

  const { selectStartDate, selectEndDate } = Values

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value })
    if (e.target.name === 'selectStartDate') return setStartDate(e.target.value)
    setEndDate(e.target.value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    // const plan = await getPJPDetails({
    //   SAP_ID,
    //   startDate: selectStartDate,
    //   endDate: selectEndDate,
    // });
    // console.log("ji", plan);
    // setCsvData(plan)
    // setData(plan);
    // setLoading(true);
    setStartDate(selectStartDate)
    setEndDate(selectEndDate)
  }

  const generateExcel = async (e) => {
    e.preventDefault()
    exportExcel(csvData.map(x => ({
      'SAP ID': x?.SAP_ID,
      'Activity': x?.activity,
      'Plan Date': x?.planDate,
      'Status': x?.status,
      'Remark': x?.remark,
    })), fileName)
  }

  return (
    <>
      <Box>
        <form onSubmit={handleSubmit}>
          <Grid container xs={12} sx={{ m: 1 }}>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>Start Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectStartDate}
                  name="selectStartDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>End Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectEndDate}
                  name="selectEndDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid item xs={2} style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
              <FilterAltOutlinedIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={handleSubmit} />
              <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={generateExcel} />
            </Grid>
          </Grid>
        </form>
      </Box>
      {loading ? (
        <>
          <TableContainer component={Paper} sx={{ mb: 2.5 }}>
            <Table>
              <TableHead >
                <TableRow >
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>SAP_ID</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Status</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Activity</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Plan Date</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Details</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Approve</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Revert</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data?.length > 0
                  ? data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">{d?.SAP_ID}</TableCell>
                      <TableCell align="center" style={d.status === "Approved" ? approvedStyle : (d?.status === "Reverted" ? revertedStyle : normalStyle)}>{d?.status}</TableCell>
                      <TableCell align="center">{d?.activity}</TableCell>
                      <TableCell align="center">
                        {new Date(d?.planDate).toDateString()}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ cursor: "pointer" }}
                      // onClick={() => {
                      //   setOpen(true);
                      //   setBeats(d?.beats);
                      //   setDealers(d?.dealers);
                      //   setModelData(d)
                      // }}
                      >
                        {
                          d?.activity === "Field" ? <VisibilityIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setOpen(true)
                              setBeats(d?.beats);
                              setDealers(d?.dealersDetails);
                              setModelData(d)
                            }}
                          /> : <VisibilityIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              // setOpen(true)
                              setOpenModal(true)
                              setRemark(d?.remark)
                              // setBeats(d?.beats);
                              // setDealers(d?.dealers);
                              // setModelData(d)
                            }}
                          />
                        }

                      </TableCell>
                      <TableCell align="center">
                        {d.status === "In-Review" ? (
                          <Button onClick={() => handleApprove(d._id)} variant='contained'>Approve</Button>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {d.status === "In-Review" ? (
                          <Button onClick={() => handleRevert(d._id)} variant='contained' color="error">Revert</Button>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                  : <Box sx={{ textAlign: 'left', pt: 1 }}>
                    <Typography variant="h6" sx={{ p: 1 }}>No PJP avilable for this SO.</Typography>
                  </Box>}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )}

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        style={{ display: "flex", justifyContent: 'center', alignItems: 'center', scrollbarWidth: 'none', borderRadius: '5px' }}
      >
        <Box sx={{ height: '75vh', overflowY: "scroll", width: '60vw', backgroundColor: 'white', scrollbarWidth: 'none', padding: '0.7rem' }}>
          <Typography variant="h4" sx={{ p: 2 }} style={{ textAlign: 'center' }}>Beat Details</Typography>
          <Grid>
            {modelData?.beats?.length ? (
              modelData?.beats.map((x) => {
                return (
                  <>
                    <TableContainer component={Paper} style={{ border: '1px solid darkgrey', marginBottom: '1rem', height: '42vh' }}>
                      <Table >
                        <TableRow>
                          <TableCell variant="head" sx={{ fontWeight: 'bolder', width: '120px' }}>Beat Name</TableCell>
                          <TableCell>{x?.name}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell variant="head" sx={{ fontWeight: 'bolder' }}>Beat Route</TableCell>
                          <TableCell>{x?.route}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell variant="head" sx={{ fontWeight: 'bolder' }}>Start Point</TableCell>
                          <TableCell>{x?.startPoint.name}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell variant="head" sx={{ fontWeight: 'bolder' }}>End Point</TableCell>
                          <TableCell>{x?.endPoint.name}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell variant="head" sx={{ fontWeight: 'bolder' }}>Dealers </TableCell>
                          <TableCell>{dealers.map((terr) => {
                            // { console.log("first", terr) }
                            return (
                              <div className="tooltip" style={{ cursor: 'pointer' }}>{terr?.dealerCode[0]},
                                <span className="tooltiptext">{terr?.name[0]}</span>
                              </div>
                            );
                          })}</TableCell>
                        </TableRow>
                      </Table>
                    </TableContainer>
                  </>
                );
              })
            ) : (
              <Typography variant="h5" sx={{ p: 2 }}>Beats Details Not Available.</Typography>
            )}
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false)
          setRemark('')
        }}
        style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}
      >
        <Box sx={{ height: '50vh', width: '40vw', backgroundColor: 'white', padding: '0.7rem' }}>
          <Typography variant="h4" sx={{ p: 2 }} style={{ textAlign: 'center' }}>Beat Details</Typography>
          <Grid>
            <TableContainer component={Paper} style={{ border: '1px solid darkgrey', marginBottom: '1rem' }}>
              <Table >
                <TableRow>
                  <TableCell variant="head" sx={{ fontWeight: 'bolder', width: '120px' }}>Remark</TableCell>
                  <TableCell>{remark ? remark : "Remark Not Available."}</TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default PJPList;
